import SbButton from '@Components/Button';
import DateRangePicker from '@Components/DateRangePicker';
import SBDropdown from '@Components/Dropdown';
import { DropdownOptionType } from '@Components/Dropdown/Type';
import FilterSelect from '@Components/Filter/Dropdown';
import FilterSearch from '@Components/Filter/Search';
import Loader from '@Components/Loader';
import { SBTable, SBTableWrapper } from '@Components/Table/Table';
import { TableHeadCell, TableRowCell } from '@Components/Table/TableCell';
import { SBTableRow } from '@Components/Table/TableRow';
import Title from '@Components/Title';
import { USER_STATUS_COLOR } from '@Constants/status';
import { getTransactionList } from '@Reducers/TransactionHistory';
import { TransactionObj } from '@Reducers/TransactionHistory/Type';
import { AppDispatch, RootStateType } from '@Store';
import CallMadeIcon from '@mui/icons-material/CallMade';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import {
  Box,
  SelectChangeEvent,
  TableBody,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material';
import { styled } from '@mui/system';
import moment from 'moment';
import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getCopilotRedirectFilters, getCopilotRedirectApiUrl, parseApiUrl } from '@Components/Bot/utils/redirectHelper';
import { FilterObj } from './Types';
import { PaymentModeList, SearchFilterList, StatusList } from './constant';
import { AmountTypo, CreditedIcon, DebitedIcon, TableActionContainer, TransactionStatus } from './style';
import ExportBtn from '@Components/Button/Export';
import { fetchTransactionExport } from '@Reducers/DownloadTransactionReport/DownloadTransactionReportSlice';
import { SuccessErrorModalOpen, SuccessErrorModalReset } from '@Reducers/SuccessErrorModal';
import { getAllReadNotifications, getAllUnreadNotifications } from '@Reducers/Notifications/actions';
import { toggleBoolean } from '@Reducers/booleanSlice/booleanSlice';
import { formatNumber, useLocale } from '../../utils/formatNumber';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AISmartSearch from '../ShipmentHistory/AISmartSearch';
import { AISearchResult } from '../ShipmentHistory/AISmartSearch/types';

interface TrasactionHistoryQuery {
  fromDate: string;
  toDate: string;
  currentPage: number;
  perPage: number;

  mode?: string[];
  status?: string[];
  searchKey?: string;
  searchValue?: string;
  accountType?: string;
  type?: string;
}

function TransactionTable() {
  const {
    data: { list, currentPage = 1, perPage },
  } = useSelector((state: RootStateType) => state.transactionHistory);
  const orgCurrency = useSelector((state: RootStateType) => state.orgSetup.organizationData?.currency?.name || '');
  const organizationData = useSelector((state: RootStateType) => state.orgSetup.organizationPublicData);
  const { name = '' } = organizationData || {};
  const locale = useLocale();

  function getTransactionType(obj: TransactionObj) {
    const label =
      obj.paymentFor === 'shipment' ? 'Shipment No' : obj.paymentFor === 'invoice' ? 'Invoice No' : 'Wallet';
    return (
      <div>
        <Typography>{label}</Typography>
        <Typography>{obj.paymentForNumber}</Typography>
      </div>
    );
  }

  return (
    <SBTableWrapper>
      <SBTable>
        <TableHead
          sx={{
            th: {
              textAlign: 'center !important',
            },
          }}
        >
          <TableRow>
            <TableHeadCell style={{ minWidth: '80px' }}>Sr No.</TableHeadCell>
            <TableHeadCell sx={{ minWidth: '180px' }}>Account Details</TableHeadCell>
            <TableHeadCell sx={{ minWidth: '250px' }}>Mode</TableHeadCell>
            <TableHeadCell sx={{ minWidth: '200px' }}>Transaction Type</TableHeadCell>
            <TableHeadCell sx={{ minWidth: '250px' }}>Transaction ID</TableHeadCell>
            <TableHeadCell sx={{ minWidth: '160px' }}>Date</TableHeadCell>
            <TableHeadCell sx={{ minWidth: '200px' }}>Amount</TableHeadCell>
            <TableHeadCell sx={{ minWidth: '180px' }}>Status</TableHeadCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {list.map((item, index) => (
            <SBTableRow key={item._id}>
              <TableRowCell
                align="center"
                className="md-text"
                sx={{
                  div: {
                    justifyContent: 'center',
                  },
                }}
              >
                {index + 1 + (currentPage - 1) * perPage}
              </TableRowCell>
              <TableRowCell className="sm-text">
                {item?.isAccountHolder ? (
                  <>
                    <Typography className="sm-text">{item?.company ? item?.company : item?.name || 'N/A'} </Typography>
                    <Typography className="sm-text">{item?.accountNumber} </Typography>
                  </>
                ) : (
                  <Typography className="sm-text"> {item?.company ? item?.company : item?.name || 'N/A'} </Typography>
                )}
              </TableRowCell>
              <TableRowCell>
                <div className="flex">
                  {item.type === 'debit' ? (
                    <DebitedIcon>
                      <CallMadeIcon />
                    </DebitedIcon>
                  ) : (
                    <CreditedIcon>
                      <CallReceivedIcon />
                    </CreditedIcon>
                  )}
                  <Typography className="md-text">{PaymentModeList[item.mode]?.display}</Typography>
                </div>
              </TableRowCell>
              <TableRowCell className="sm-text">{getTransactionType(item)}</TableRowCell>
              <TableRowCell className="sm-text">{item?.gatewayPaymentId || item._id}</TableRowCell>
              <TableRowCell
                className="sm-text"
                align="center"
                sx={{
                  div: {
                    justifyContent: 'center',
                  },
                }}
              >
                {moment(item.createdAt).format('DD/MM/YYYY')}
              </TableRowCell>
              <TableRowCell
                className="sm-text"
                align="center"
                sx={{
                  div: {
                    justifyContent: 'center',
                  },
                }}
              >
                {/* <AmountTypo type={item.type}> */}
                {name === 'Cargo Solutions Network' ? (
                  <>
                    <b>
                      {item.currency} {formatNumber(Number(item.amount), locale)}
                    </b>
                    {item.currency !== orgCurrency || Number(item.amount) !== Number(item.amountInOrgCurrency)
                      ? `(≈ ${orgCurrency} ${item.amountInOrgCurrency})`
                      : ''}
                  </>
                ) : (
                  <AmountTypo type={item.type}>
                    {item.currency || orgCurrency} {formatNumber(Number(item.amount), locale)}
                  </AmountTypo>
                )}
                {/* </AmountTypo> */}
              </TableRowCell>
              <TableRowCell align="center" className="sm-text">
                <TransactionStatus
                  bgcolor={USER_STATUS_COLOR[item.status].bgColor}
                  color={USER_STATUS_COLOR[item.status].textColor}
                >
                  {USER_STATUS_COLOR[item.status]?.text}
                </TransactionStatus>
              </TableRowCell>
            </SBTableRow>
          ))}
        </TableBody>
      </SBTable>
    </SBTableWrapper>
  );
}

const FilterSectionContainer = styled('div')`
  display: grid;
  grid-template-columns: repeat(4, minmax(220px, 1fr));
  gap: 20px;
  margin-bottom: 30px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const FilterCard = styled('div')(({ theme }) => ({
  padding: '18px',
  borderRadius: '16px',

  position: 'relative',
  overflow: 'hidden',
  cursor: 'pointer',

  background: `linear-gradient(
    135deg,
    ${theme.palette.primary.light}22,
    ${theme.palette.secondary.light}18
  )`,

  backdropFilter: 'blur(14px)',
  WebkitBackdropFilter: 'blur(14px)',

  border: '1px solid transparent',

  transition: 'all 0.25s ease',

  boxShadow: `
    0 10px 28px rgba(0,0,0,0.12),
    inset 0 1px 0 rgba(255,255,255,0.08)
  `,

  // 🌈 gradient border
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    padding: '1px',
    borderRadius: '16px',
    background: `linear-gradient(
      135deg,
      ${theme.palette.primary.main},
      ${theme.palette.secondary.main}
    )`,
    WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    WebkitMaskComposite: 'xor',
    maskComposite: 'exclude',
    pointerEvents: 'none',
    opacity: 0.5,
  },

  // ✨ HOVER GLOW EFFECT
  '&:hover': {
    transform: 'translateY(-4px) scale(1.01)',
    boxShadow: `
      0 18px 45px rgba(0,0,0,0.18),
      0 0 25px ${theme.palette.primary.main}40,
      0 0 40px ${theme.palette.secondary.main}30
    `,
  },
}));

const FilterLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main, // 👈 now theme primary
  fontSize: '18px',
  fontWeight: 500,
  letterSpacing: '0.2px',
}));

const CardIcon = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 12,
  right: 12,

  color: theme.palette.primary.main,
  opacity: 0.18,

  '& svg': {
    fontSize: 42,
  },
}));

function Navigation(props: {
  daysFilter: string;
  setDaysFilter: (val: string) => void;
  accountType: string;
  setAccountType: (val: string) => void;
  setType: React.Dispatch<React.SetStateAction<string>>;
  setDateRange: (
    value: React.SetStateAction<{
      startDate: Date;
      endDate: Date;
    }>,
  ) => void;
}) {
  const { accountTypeList } = useSelector((state: RootStateType) => state?.global);
  const { setDaysFilter, accountType, setAccountType, setDateRange } = props;
  const {
    data: { totalCount },
  } = useSelector((state: RootStateType) => state.transactionHistory);
  const theme = useTheme();
  const orgCountryCurrency = useSelector(
    (state: RootStateType) => state.orgSetup.organizationData?.currency?.name || '',
  );
  const defaultOrgCountryCurrency = useSelector(
    (state: RootStateType) => state.orgSetup.organizationData?.currency?.name || '',
  );
  const organizationData = useSelector((state: RootStateType) => state.orgSetup.organizationPublicData);
  const { name = '' } = organizationData || {};

  function handleDropdownChange(
    _selected: Array<string>,
    _selectedObj: DropdownOptionType[],
    event: SelectChangeEvent<string>,
    _child: React.ReactNode,
  ) {
    if (event.target.name === 'accountType') setAccountType(event.target.value);
    else if (event.target.name === 'dateFilter') {
      setDaysFilter(event.target.value);
      const dateRange = {
        startDate: moment().subtract(event.target.value, 'days').startOf('day').toDate(),
        endDate: moment().endOf('day').toDate(),
      };
      setDateRange(dateRange);
    }
  }

  return (
    <FilterSectionContainer>
      {name !== 'Cargo Solutions Network' && (
        <>
          {/* CARD 1 - Transactions */}
          <FilterCard>
            <CardIcon>
              <ReceiptLongIcon />
            </CardIcon>

            <FilterLabel>Transactions</FilterLabel>
            <FilterLabel className="md-text">{totalCount}</FilterLabel>
          </FilterCard>

          {/* CARD 2 - Account Type */}
          <FilterCard>
            <CardIcon>
              <AccountTreeIcon />
            </CardIcon>

            <FilterLabel>Account Type</FilterLabel>

            <SBDropdown
              id="bank-acc-type"
              label=""
              required
              placeholder="Select Account Type"
              name="accountType"
              options={accountTypeList}
              value={[accountType]}
              onChange={handleDropdownChange}
              sx={{
                '&.MuiInputBase-root': {
                  backgroundColor: 'transparent',
                },
                '&.MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: '0px',
                },
                '.MuiSelect-select': {
                  height: 'unset',
                  padding: 0,
                },
                '.MuiTypography-root': {
                  whiteSpace: 'pre-wrap',
                  color: theme.palette.primary.main,
                },
                '.MuiOutlinedInput-notchedOutline': {
                  borderWidth: 0,
                },
              }}
            />
          </FilterCard>

          {/* CARD 3 - Debit */}
          <FilterCard>
            <CardIcon>
              <CallMadeIcon />
            </CardIcon>

            <FilterLabel>Total Debit ({defaultOrgCountryCurrency || orgCountryCurrency})</FilterLabel>

            <Box onClick={() => props.setType('debit')} className="cursor-pointer underline color-p-main">
              view transactions
            </Box>
          </FilterCard>

          {/* CARD 4 - Credit */}
          <FilterCard>
            <CardIcon>
              <CallReceivedIcon />
            </CardIcon>

            <FilterLabel>Total Credit ({defaultOrgCountryCurrency || orgCountryCurrency})</FilterLabel>

            <Box onClick={() => props.setType('credit')} className="cursor-pointer underline color-p-main">
              view transactions
            </Box>
          </FilterCard>
        </>
      )}
    </FilterSectionContainer>
  );
}

const normalizeTransactionSearchKey = (key?: string): string => {
  if (!key) return 'accountNumber';
  const lower = key.toLowerCase().replace(/[-_]/g, '');
  if (lower.includes('account')) return 'accountNumber';
  if (lower.includes('invoice')) return 'invoiceNumber';
  if (lower.includes('shipment') || lower.includes('awb') || lower.includes('tracking')) return 'shipmentNumber';
  if (lower.includes('transaction')) return 'transactionId';
  if (lower.includes('name')) return 'name';
  if (lower.includes('email')) return 'email';
  return key;
};

export default function Transactions() {
  const location = useLocation();
  const copilotFilters = useMemo(() => getCopilotRedirectFilters(location.search), [location.search]);
  const copilotApiUrl = useMemo(() => getCopilotRedirectApiUrl(location.search), [location.search]);

  const parsedInitialUrl = useMemo(() => parseApiUrl(copilotApiUrl), [copilotApiUrl]);
  const [activeCustomBasePath, setActiveCustomBasePath] = useState<string | null>(() => parsedInitialUrl.basePath);
  const [copilotActiveFilters, setCopilotActiveFilters] = useState<Record<string, unknown>>(() => ({
    ...parsedInitialUrl.queryParams,
    ...(copilotFilters || {}),
  }));
  const [filterSelectValue, setFilterSelectValue] = useState<string>(() =>
    normalizeTransactionSearchKey(
      (copilotFilters?.searchKey as string) || (parsedInitialUrl.queryParams.searchKey as string),
    ),
  );
  const [filterText, setFilterText] = useState<string>(
    () => (copilotFilters?.searchValue as string) || (parsedInitialUrl.queryParams.searchValue as string) || '',
  );
  const [mode, setMode] = useState<string[]>(() => {
    const raw = copilotFilters?.mode || parsedInitialUrl.queryParams.mode;
    if (raw) {
      return Array.isArray(raw) ? (raw as string[]) : [String(raw)];
    }
    return [];
  });
  const [status, setStatus] = useState<string[]>(() => {
    const raw = copilotFilters?.status || parsedInitialUrl.queryParams.status;
    if (raw) {
      return Array.isArray(raw) ? (raw as string[]) : [String(raw)];
    }
    return [];
  });
  const [daysFilter, setDaysFilter] = useState<string>(() => {
    const from = copilotFilters?.fromDate || parsedInitialUrl.queryParams.fromDate;
    const to = copilotFilters?.toDate || parsedInitialUrl.queryParams.toDate;
    if (from && to) return '';
    return '15';
  });
  const [accountType, setAccountType] = useState<string>(() => {
    const raw = copilotFilters?.accountType || parsedInitialUrl.queryParams.accountType;
    if (raw) return String(raw);
    return '';
  });
  const [dateRange, setDateRange] = useState(() => {
    const from = copilotFilters?.fromDate || parsedInitialUrl.queryParams.fromDate;
    const to = copilotFilters?.toDate || parsedInitialUrl.queryParams.toDate;
    if (from && to) {
      return {
        startDate: moment(from as string, ['DD/MM/YYYY', 'YYYY-MM-DD'])
          .startOf('day')
          .toDate(),
        endDate: moment(to as string, ['DD/MM/YYYY', 'YYYY-MM-DD'])
          .endOf('day')
          .toDate(),
      };
    }
    return {
      startDate: moment().subtract(15, 'days').startOf('day').toDate(),
      endDate: moment().endOf('day').toDate(),
    };
  });
  const [type, setType] = useState<string>(() => {
    const raw = copilotFilters?.type || parsedInitialUrl.queryParams.type;
    if (raw) {
      return Array.isArray(raw) ? (raw[0] as string) : String(raw);
    }
    return '';
  });
  const [loader, setLoader] = useState<boolean>(false);
  const [isAiGlowActive, setIsAiGlowActive] = useState<boolean>(false);
  const [activeAiFilters, setActiveAiFilters] = useState<any>(null);
  const { limit } = useSelector((state: RootStateType) => state.notifications);
  const { accountTypeList = [] } = useSelector((state: RootStateType) => state?.global || {});

  const dispatch = useDispatch<AppDispatch>();

  const {
    data: { currentPage = 1, perPage, totalCount },
    loading,
  } = useSelector((state: RootStateType) => state.transactionHistory);

  const [prevSearchObj, setPrevSearchObj] = useState<string>('');
  const isMountedRef = useRef(false);

  const transactionAiSuggestions = useMemo(
    () => [
      'Show successful transactions',
      'Show pending transactions',
      'Show failed transactions',
      'Show wallet transactions',
      'Show cash transactions',
      'Show transactions from last 30 days',
    ],
    [],
  );

  const aiEnumOptions = useMemo(() => {
    return {
      mode: Object.values(PaymentModeList).map(m => ({ label: m.display || '', value: m.value })),
      status: Object.values(StatusList).map(s => ({ label: s.display || '', value: s.value })),
      accountType: (accountTypeList || []).map((a: any) => ({ label: a.display || a.label || '', value: a.value })),
    };
  }, [accountTypeList]);

  useEffect(() => {
    if (!loading) {
      setIsAiGlowActive(false);
    }
  }, [loading]);

  const getFilterObj = useCallback(
    (
      options: FilterObj,
      overrideCopilotFilters?: Record<string, unknown>,
      overrideAiFilters?: any,
    ): TrasactionHistoryQuery => {
      const activeCopilot = overrideCopilotFilters !== undefined ? overrideCopilotFilters : copilotActiveFilters;
      const aiFilters = overrideAiFilters !== undefined ? overrideAiFilters : activeAiFilters;

      let filterDate = options.dateRange || dateRange;
      if (options.daysFilter) {
        filterDate = {
          startDate: moment().subtract(options.daysFilter, 'days').startOf('day').toDate(),
          endDate: moment().endOf('day').toDate(),
        };
      }
      let fromDate = moment(filterDate.startDate).format('DD/MM/YYYY');
      let toDate = moment(filterDate.endDate).format('DD/MM/YYYY');

      if (!options.dateRange && !options.daysFilter && aiFilters) {
        if (aiFilters.fromDate) {
          fromDate = moment(aiFilters.fromDate, ['YYYY-MM-DD', 'DD/MM/YYYY']).format('DD/MM/YYYY');
        }
        if (aiFilters.toDate) {
          toDate = moment(aiFilters.toDate, ['YYYY-MM-DD', 'DD/MM/YYYY']).format('DD/MM/YYYY');
        }
      }

      const filterMode = aiFilters?.mode
        ? Array.isArray(aiFilters.mode)
          ? aiFilters.mode
          : [aiFilters.mode]
        : options.mode || mode;

      const filterStatus = aiFilters?.status
        ? Array.isArray(aiFilters.status)
          ? aiFilters.status
          : [aiFilters.status]
        : options.status || status;

      const filterAccountType = aiFilters?.accountType
        ? String(aiFilters.accountType)
        : options.accountType !== undefined
        ? options.accountType
        : accountType;

      const filterType = aiFilters?.type
        ? Array.isArray(aiFilters.type)
          ? String(aiFilters.type[0])
          : String(aiFilters.type)
        : options.type !== undefined
        ? options.type
        : type;

      let filterSearchKey = options.searchKey || filterSelectValue;
      let filterSearchValue = 'searchValue' in options ? options.searchValue : filterText;

      if (aiFilters) {
        if (aiFilters.searchKey && aiFilters.searchValue) {
          filterSearchKey = normalizeTransactionSearchKey(aiFilters.searchKey);
          filterSearchValue = aiFilters.searchValue;
        } else if ('searchKey' in aiFilters || 'searchValue' in aiFilters) {
          filterSearchKey = '';
          filterSearchValue = '';
        }
      }

      const compareObj = {
        fromDate,
        toDate,
        mode: filterMode,
        status: filterStatus,
        searchKey: filterSearchKey,
        searchValue: filterSearchValue,
        accountType: filterAccountType,
      };
      if (prevSearchObj !== '' && JSON.stringify(compareObj) !== prevSearchObj) {
        options.currentPage = 1;
      }
      setPrevSearchObj(JSON.stringify(compareObj));

      const {
        fromDate: _cFromDate,
        toDate: _cToDate,
        dateRange: _cDateRange,
        status: _cStatus,
        mode: _cMode,
        type: _cType,
        accountType: _cAccountType,
        searchKey: _cSearchKey,
        searchValue: _cSearchValue,
        currentPage: _cCurrentPage,
        perPage: _cPerPage,
        ...extraCopilotParams
      } = activeCopilot;

      const payload: any = {
        ...extraCopilotParams,
        currentPage: options.currentPage || currentPage,
        perPage: options.perPage || perPage,
        fromDate,
        toDate,
        mode: filterMode,
        status: filterStatus,
        searchKey: filterSearchKey,
        searchValue: filterSearchValue,
        ...(filterAccountType ? { accountType: filterAccountType } : {}),
        ...(filterType ? { type: filterType } : {}),
      };
      if (!filterSearchValue) {
        delete payload['searchKey'];
        delete payload['searchValue'];
      }
      return payload;
    },
    [
      activeAiFilters,
      copilotActiveFilters,
      dateRange,
      mode,
      status,
      accountType,
      type,
      filterSelectValue,
      filterText,
      prevSearchObj,
      currentPage,
      perPage,
    ],
  );

  const applyFilters = useCallback(
    (
      options: FilterObj,
      overrideBasePath?: string | null,
      overrideCopilotFilters?: Record<string, unknown>,
      overrideAiFilters?: any,
    ) => {
      const activeBasePath = overrideBasePath !== undefined ? overrideBasePath : activeCustomBasePath;
      const query = getFilterObj(options, overrideCopilotFilters, overrideAiFilters);
      if (activeBasePath) {
        dispatch(getTransactionList({ customApiUrl: activeBasePath, ...query }));
      } else {
        dispatch(getTransactionList(query));
      }
    },
    [activeCustomBasePath, dispatch, getFilterObj],
  );

  const handleAiResults = useCallback(
    (filters: AISearchResult['filters'] | null, activeResult: AISearchResult | null, error?: any) => {
      if (error) {
        setIsAiGlowActive(false);
        dispatch(
          SuccessErrorModalOpen({
            type: 'error',
            title: error?.msg || error?.response?.data?.msg || 'Failed to extract search filters',
            subTitle: error?.response?.data?.errorDetails || 'Please verify your query syntax and try again.',
          }),
        );
        return;
      }

      if (!activeResult) {
        setActiveAiFilters(null);
        applyFilters({ currentPage: 1 }, undefined, undefined, null);
        return;
      }

      if (filters) {
        setActiveAiFilters(filters);

        const finalFromDate = filters.fromDate
          ? moment(filters.fromDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
          : moment(dateRange.startDate).format('DD/MM/YYYY');
        const finalToDate = filters.toDate
          ? moment(filters.toDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
          : moment(dateRange.endDate).format('DD/MM/YYYY');

        const finalStatus = Array.isArray(filters.status) ? filters.status : filters.status ? [filters.status] : status;

        const finalMode = Array.isArray(filters.mode) ? filters.mode : filters.mode ? [filters.mode] : mode;

        const finalAccountType = filters.accountType ? String(filters.accountType) : accountType;
        const finalType = filters.type
          ? Array.isArray(filters.type)
            ? String(filters.type[0])
            : String(filters.type)
          : type;

        const mergedOptions: FilterObj = {
          currentPage: 1,
          perPage,
          dateRange: {
            startDate: moment(finalFromDate, 'DD/MM/YYYY').toDate(),
            endDate: moment(finalToDate, 'DD/MM/YYYY').toDate(),
          },
          status: finalStatus,
          mode: finalMode,
          accountType: finalAccountType,
          type: finalType,
        };

        if (filters.searchKey && filters.searchValue) {
          mergedOptions.searchKey = normalizeTransactionSearchKey(filters.searchKey);
          mergedOptions.searchValue = filters.searchValue;
        }

        applyFilters(mergedOptions, undefined, undefined, filters);
      }
    },
    [dispatch, applyFilters, dateRange, status, mode, accountType, type, perPage],
  );

  const onDateChange = ({ startDate, endDate }: { startDate: Date; endDate: Date }, isOpen: boolean) => {
    if (isOpen) return;
    const dateRange = { startDate, endDate };
    setDateRange(dateRange);
    applyFilters({ dateRange, currentPage: 1 });
  };

  const onStatusFilterChange = (selected: Array<string>) => {
    setStatus(selected);
    applyFilters({ status: selected, currentPage: 1 });
  };

  const onModeFilterChange = (selected: Array<string>) => {
    setMode(selected);
    applyFilters({ mode: selected, currentPage: 1 });
  };

  useEffect(() => {
    const currentCopilotApiUrl = getCopilotRedirectApiUrl(location.search);
    const currentCopilotFilters = getCopilotRedirectFilters(location.search);

    const parsedUrl = parseApiUrl(currentCopilotApiUrl);
    const basePath = parsedUrl.basePath;
    const mergedCopilot = { ...parsedUrl.queryParams, ...(currentCopilotFilters || {}) };

    setActiveCustomBasePath(basePath);
    setCopilotActiveFilters(mergedCopilot);

    if (currentCopilotFilters || Object.keys(mergedCopilot).length > 0 || basePath) {
      let nextDateRange = dateRange;
      if (mergedCopilot.fromDate && mergedCopilot.toDate) {
        nextDateRange = {
          startDate: moment(mergedCopilot.fromDate as string, ['DD/MM/YYYY', 'YYYY-MM-DD'])
            .startOf('day')
            .toDate(),
          endDate: moment(mergedCopilot.toDate as string, ['DD/MM/YYYY', 'YYYY-MM-DD'])
            .endOf('day')
            .toDate(),
        };
        setDateRange(nextDateRange);
        setDaysFilter('');
      }
      let filterModes = mode;
      if (mergedCopilot.mode) {
        filterModes = Array.isArray(mergedCopilot.mode)
          ? (mergedCopilot.mode as string[])
          : [String(mergedCopilot.mode)];
        setMode(filterModes);
      }
      let filterStats = status;
      if (mergedCopilot.status) {
        filterStats = Array.isArray(mergedCopilot.status)
          ? (mergedCopilot.status as string[])
          : [String(mergedCopilot.status)];
        setStatus(filterStats);
      }
      let filterAcc = accountType;
      if (mergedCopilot.accountType) {
        filterAcc = String(mergedCopilot.accountType);
        setAccountType(filterAcc);
      }
      let filterTyp = type;
      if (mergedCopilot.type) {
        filterTyp = Array.isArray(mergedCopilot.type) ? (mergedCopilot.type[0] as string) : String(mergedCopilot.type);
        setType(filterTyp);
      }
      let filterSearchKey = filterSelectValue;
      if (mergedCopilot.searchKey) {
        filterSearchKey = normalizeTransactionSearchKey(mergedCopilot.searchKey as string);
        setFilterSelectValue(filterSearchKey);
      }
      let filterSearchVal = filterText;
      if (mergedCopilot.searchValue) {
        filterSearchVal = String(mergedCopilot.searchValue);
        setFilterText(filterSearchVal);
      }

      applyFilters(
        {
          currentPage: 1,
          perPage: 10,
          dateRange: nextDateRange,
          mode: filterModes,
          status: filterStats,
          accountType: filterAcc,
          type: filterTyp,
          searchKey: filterSearchKey,
          searchValue: filterSearchVal,
        },
        basePath,
        mergedCopilot,
      );
    } else {
      setActiveCustomBasePath(null);
      setCopilotActiveFilters({});
      dispatch(getTransactionList({ currentPage: 1, perPage: 10 }));
    }
  }, [location.search]);

  useEffect(() => {
    if (!isMountedRef.current) {
      isMountedRef.current = true;
      return;
    }
    if (daysFilter || type) {
      applyFilters({ daysFilter, type, currentPage: 1 });
    }
  }, [daysFilter, type]);

  useEffect(() => {
    if (!isMountedRef.current) return;
    applyFilters({ accountType, currentPage: 1 });
  }, [accountType]);

  const handleExport = () => {
    try {
      setLoader(true);
      const fromDate = getFilterObj({}).fromDate;
      const toDate = getFilterObj({}).toDate;
      dispatch(
        fetchTransactionExport({
          fromDate,
          toDate,
          mode,
          status,
          searchKey: filterSelectValue,
          searchValue: filterText,
        }),
      );

      dispatch(
        getAllUnreadNotifications({
          page: 1,
          limit,
        }),
      );
      dispatch(getAllReadNotifications({ page: 1, limit }));
      dispatch(
        SuccessErrorModalOpen({
          type: 'success',
          title: 'Download in Progress',
          subTitle: 'Your report is being generated. It will be available shortly in the downloads bar',
          btnText: 'Close',
          onConfirm: () => {
            dispatch(toggleBoolean());
            dispatch(SuccessErrorModalReset());
          },
        }),
      );
    } catch (error) {
      dispatch(
        SuccessErrorModalOpen({
          type: 'error',
          title: 'Something went wrong',
          subTitle: 'please try after sometimes',
        }),
      );
    } finally {
      setLoader(false);
    }
  };

  return (
    <Loader loading={loading} overly>
      <>
        <Title title="Transactions" removeBorder subTitle="View transactions for all users" />

        <Navigation
          daysFilter={daysFilter}
          setDaysFilter={setDaysFilter}
          accountType={accountType}
          setAccountType={setAccountType}
          setDateRange={setDateRange}
          setType={setType}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },
          }}
        >
          <Loader loading={loader} overly />
          <ExportBtn
            iconSrc="/images/file_download.svg"
            width={25}
            alt="Export"
            label="Export"
            onClick={() => {
              handleExport();
            }}
          />
        </Box>

        <AISmartSearch
          isOpen={true}
          onClose={() => undefined}
          onResults={handleAiResults}
          isGlowActive={isAiGlowActive}
          enumOptions={aiEnumOptions}
          onSearchStart={() => setIsAiGlowActive(true)}
          totalRecords={totalCount}
          isListLoading={loading}
          type="transactionList"
          defaultSuggestions={transactionAiSuggestions}
          emptyStateTitle="I couldn't find transactions matching:"
          hideCloseButton={true}
        />

        {!activeAiFilters && (
          <TableActionContainer>
            <FilterSearch
              onSelectChange={(value: string) => {
                setFilterSelectValue(value);
              }}
              list={SearchFilterList}
              selectValue={filterSelectValue}
              textValue={filterText}
              onTextChange={e => {
                setFilterText(e.target.value);
              }}
              onTextSearch={() => {
                applyFilters({ searchValue: filterText, currentPage: 1 });
              }}
              onTextClear={() => {
                setFilterText('');
                applyFilters({ searchValue: undefined, currentPage: 1 });
              }}
            />
            <div className="whiteSpace"></div>
            <DateRangePicker onChange={onDateChange} value={dateRange} />
            <FilterSelect
              id="mode"
              label="Mode"
              value={mode}
              options={Object.values(PaymentModeList)}
              onChange={onModeFilterChange}
            />
            <FilterSelect
              id="status"
              label="Status"
              value={status}
              options={Object.values(StatusList)}
              onChange={onStatusFilterChange}
            />
            <SbButton
              className="xs-text ml-1"
              variant="outlined"
              sx={{ borderRadius: '8px !important', padding: '8px !important' }}
              onClick={() => {
                setActiveCustomBasePath(null);
                setCopilotActiveFilters({});
                setActiveAiFilters(null);
                setStatus([]);
                setFilterText('');
                setMode([]);
                const defaultDateRange = {
                  startDate: moment().subtract(1, 'months').startOf('day').toDate(),
                  endDate: moment().endOf('day').toDate(),
                };
                setDateRange(defaultDateRange);
                setType('');
                setAccountType('');
                setDaysFilter('15');
                applyFilters(
                  {
                    status: [],
                    searchValue: '',
                    mode: [],
                    type: '',
                    accountType: '',
                    dateRange: defaultDateRange,
                    currentPage: 1,
                  },
                  null,
                  {},
                  null,
                );
              }}
            >
              Clear Filters
            </SbButton>
          </TableActionContainer>
        )}
        <TransactionTable />
        {!!totalCount && !!perPage && (
          <>
            <TablePagination
              component="div"
              count={totalCount}
              page={currentPage - 1}
              rowsPerPage={perPage}
              onPageChange={(_, page) => {
                applyFilters({ currentPage: page + 1 });
              }}
              onRowsPerPageChange={event => {
                applyFilters({ perPage: parseInt(event.target.value), currentPage: 1 });
              }}
            />
          </>
        )}
      </>
    </Loader>
  );
}
